Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoDescriptionReset = exports.videoVideoElementStyle = void 0;
exports.videoVideoElementStyle = {
  ncss: {
    objectFit: 'cover',
    height: 'auto',
    width: '100%',
    '&:focus': {
      outlineColor: 'black',
      outlineOffset: 4,
      outlineWidth: 2,
      outlineStyle: 'dotted'
    }
  }
};
exports.videoDescriptionReset = {
  ncss: {
    boxSizing: 'border-box',
    fontFamily: 'text'
  }
};